// extracted by mini-css-extract-plugin
export var container = "_37-0";